<template>
  <v-menu
    transition="scale-transition"
    :close-on-content-click="false"
    v-model="menu"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn rounded v-on="on" class="ma-1 light-green lighten-5">
        <v-icon v-if="isSelected" left dark color="green">mdi-check</v-icon>
        <v-icon left small>{{ supplierTypeIcon(serviceType) }}</v-icon>
        {{ value.serviceName }}&nbsp;-&nbsp;
        <template v-if="!isMandatory">
          <strong
            >{{ value.priceFrom }}{{ value.priceFromCurrencyCode }}</strong
          >
          &nbsp;{{ value.rateTypeCode }}
        </template>
        <template v-else-if="!menu">
          <item-total-price-info
            v-if="isMandatory"
            :service-id="value.serviceId"
            :agent-id="headerProps.agentId"
            :adults="adults"
            :children="children"
            :infants="infants"
            :qty="qty"
            :start-date="startDate"
            :end-date="endDate"
            :department="headerProps.departmentName"
            @onLoad="onPriceLoaded"
            @onLoadError="onGetPriceError"
            :skip="!isMandatory"
            :get-price="getPriceBreakDown"
            small
          ></item-total-price-info>
        </template>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <h3 class="title">
          {{ value.supplierName }} - {{ value.serviceName }}&nbsp;-&nbsp;
          <strong
            >{{ value.priceFrom }}{{ value.priceFromCurrencyCode }}</strong
          >
          &nbsp;{{ value.rateTypeCode }}
        </h3>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <date-picker
              v-model="startDate"
              :outlined="outlinedInputs"
              custom-label="Date From"
              @onDateSelected="onStartDateSelected"
              :range-start="startDateRangeStart"
              :range-end="startDateRangeEnd"
            ></date-picker>
          </v-col>
          <v-col>
            <date-picker
              v-model="endDate"
              :outlined="outlinedInputs"
              @onDateSelected="onEndDateSelected"
              custom-label="Date To"
              :disabled="isSameDayServiceType"
              :range-start="endDateRangeStart"
              :range-end="endDateRangeEnd"
            ></date-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="adults"
              label="Adults"
              :outlined="outlinedInputs"
              type="number"
              @change="updateQty"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="children"
              label="Children"
              :outlined="outlinedInputs"
              type="number"
              @change="updateQty"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="infants"
              label="Infants"
              :outlined="outlinedInputs"
              type="number"
              @change="updateQty"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="qty"
              label="Qty"
              :outlined="outlinedInputs"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <item-total-price-info
              v-if="!isMandatory || menu"
              :service-id="value.serviceId"
              :agent-id="headerProps.agentId"
              :adults="adults"
              :children="children"
              :infants="infants"
              :qty="qty"
              :start-date="startDate"
              :end-date="endDate"
              :department="headerProps.departmentName"
              @onLoad="onPriceLoaded"
              @onLoadError="onGetPriceError"
              :skip="!menu"
              :get-price="getPriceBreakDown"
            ></item-total-price-info>
          </v-col>
        </v-row>
        <v-row v-if="debug">
          <v-col
            ><code>{{ value }}</code></v-col
          >
        </v-row>
      </v-card-text>
      <v-card-actions class="grey lighten-4">
        <v-spacer></v-spacer>
        <v-btn color="warning" @click="onCancel" text>Cancel</v-btn>
        <v-btn color="primary" @click="onSave">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import DatePicker from "../../../shared/DatePicker.vue";
import ItemTotalPriceInfo from "./ItemTotalPriceInfo.vue";
import { SupplierTypeIconMixin } from "../../../../../mixins/SupplierTypeIconMixin";
export default {
  mixins: [SupplierTypeIconMixin],
  components: { DatePicker, ItemTotalPriceInfo },
  name: "linked-service-item",
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    headerProps: {
      type: Object,
      default: () => null,
    },
    ratePlan: {
      type: String,
      default: () => null,
    },
  },

  data() {
    return {
      debug: false,
      startDate: this.value ? this.value.startDate : null,
      endDate: this.value
        ? ["ACTIVITY"].includes(this.value.serviceType)
          ? this.value.startDate
          : this.value.endDate
        : null,
      adults: this.value ? this.value.adults : null,
      children: this.value ? this.value.children : null,
      infants: this.value ? this.value.infants : null,
      qty: this.value ? this.getQty(this.value) : 1,
      serviceType: this.value ? this.value.serviceType : null,
      stdOccupancy: this.value ? parseInt(this.value.stdOccupancy) : 1,
      menu: false,
      getPriceBreakDown: true,
      itemPricing: null,
      startDateRangeStart: this.headerProps ? this.headerProps.startDate : null,
      startDateRangeEnd: this.headerProps ? this.headerProps.endDate : null,
      endDateRangeStart: this.headerProps ? this.headerProps.startDate : null,
      endDateRangeEnd: this.headerProps ? this.headerProps.endDate : null,
    };
  },

  computed: {
    isSameDayServiceType() {
      return ["ACTIVITY"].includes(this.serviceType);
    },
    isSelected() {
      return this.value.isSelected;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs", true);
    },
    isMandatory() {
      return this.value && this.value.isMandatory;
    },
  },

  watch: {
    value(newVal) {
      this.startDate = newVal.startDate;
      this.endDate = ["ACTIVITY"].includes(newVal.serviceType)
        ? this.startDate
        : newVal.endDate;
      this.adults = newVal.adults;
      this.children = newVal.children;
      this.infants = newVal.infants;
      this.stdOccupancy = parseInt(newVal.stdOccupancy);
      this.qty = this.getQty();
    },
    headerProps(newVal) {
      this.startDateRangeStart = newVal.startDate;
      this.startDateRangeEnd = newVal.endDate;
      this.endDateRangeStart = newVal.startDate;
      this.endDateRangeEnd = newVal.endDate;
    },
  },

  methods: {
    onStartDateSelected(startDate) {
      if (this.isSameDayServiceType) {
        this.endDate = startDate;
      }
      //update end date range start
      this.endDateRangeStart = startDate;
      //update end date range end
      this.endDateRangeEnd = this.headerProps.endDate;
    },
    onEndDateSelected(endDate) {
      //update start date range end
      this.startDateRangeEnd = endDate;
    },
    onPriceLoaded(itemPricing) {
      this.itemPricing = { ...itemPricing };
      if (this.isMandatory && !this.menu) {
        this.onSave();
      }
    },
    onGetPriceError(error) {
      console.log("onGetPriceError", error);
    },
    getQty(item = null) {
      const selectedPax =
        parseInt(item ? item.adults : this.adults) +
        parseInt(item ? item.children : this.children) +
        parseInt(item ? item.infants : this.infants);
      return Math.ceil(
        selectedPax / (item ? item.stdOccupancy : this.stdOccupancy)
      ).toString();
    },
    updateQty() {
      this.qty = this.getQty();
    },
    onSave() {
      this.menu = false;
      const pricing = this.getPricingInput();
      this.$emit("save", {
        id: this.value.id,
        status: "Quotation",
        statusId: "U2VydmljZVN0YXR1cy0x",
        serviceId: this.value.serviceId,
        adults: this.adults,
        children: this.children,
        infants: this.infants,
        qty: this.qty,
        extras: [],
        startDate: this.startDate,
        endDate: this.endDate,
        boardBasis: "",
        isHidden: false,
        isIncluded: true,
        isOptional: false,
        pricing: pricing,
        customPricing: false,
        price: this.itemPricing ? this.itemPricing.totalSell : null,
        serviceType: this.value.serviceType,
        stdOccupancy: this.value.stdOccupancy,
        serviceName: this.value.serviceName,
        supplierName: this.value.supplierName,
        supplierId: this.value.supplierId,
        rateTypeCode: pricing ? pricing.rateTypeCode : null,
        isMandatory: this.isMandatory,
        remarks: {
          pickupPoint: "",
          dropoffPoint: "",
          pickupTime: "",
          dropoffTime: "",
        },
      });
    },
    getPricingInput() {
      if (this.itemPricing) {
        return {
          adultBuy: this.itemPricing.adultBuy,
          adultSell: this.itemPricing.adultSell,
          childBuy: this.itemPricing.childBuy,
          childSell: this.itemPricing.childSell,
          infantBuy: this.itemPricing.infantBuy,
          infantSell: this.itemPricing.infantSell,
          itemBuy: this.itemPricing.itemBuy,
          itemSell: this.itemPricing.itemSell,
          rateTypeCode: this.itemPricing.rateTypeCode,
          ratePlan: this.itemPricing.ratePlan,
          currencySell: this.itemPricing.currencySell,
          currencySellExchangeRate: this.itemPricing.currencySellExchangeRate,
          currencyBuy: this.itemPricing.currencyBuy,
          currencyBuyExchangeRate: this.itemPricing.currencyBuyExchangeRate,
          discount: this.itemPricing.discount,
          discountId: this.itemPricing.discountId,
          discountCost: this.itemPricing.discountCost,
          discountSell: this.itemPricing.discountSell,
          extras: this.itemPricing.extras,
        };
      }
      return null;
    },
    onCancel() {
      console.log("onCancel");
      this.menu = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/LinkedServiceItem.vue